(() => {
  const searchPanel = document.querySelector('[data-search-panel]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchForm = document.querySelector('[data-live-search-form]');
  const searchResults = document.querySelector('[data-search-results]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartTotal = document.querySelector('[data-cart-total]');
  const overlay = document.querySelector('[data-header-overlay]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileSearchForm = document.querySelector('[data-mobile-search-form]');
  const mobileSearchInput = document.querySelector('[data-mobile-search-input]');
  const mobileSearchResults = document.querySelector('[data-mobile-search-results]');
  const header = document.querySelector('.site-header');
  const root = window.Shopify?.routes?.root || '/';
  let searchTimer;

  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  const money = cents => new Intl.NumberFormat('nb-NO', {style:'currency',currency:'NOK'}).format((Number(cents) || 0) / 100);
  const setHeaderOffset = () => {
    if (!header || !searchPanel) return;
    searchPanel.style.setProperty('--header-offset', `${Math.max(header.getBoundingClientRect().bottom, 0)}px`);
  };
  const closePanels = () => {
    if (searchPanel) searchPanel.hidden = true;
    if (cartDrawer) cartDrawer.hidden = true;
    if (mobileMenu) mobileMenu.hidden = true;
    if (overlay) overlay.hidden = true;
    searchInput?.setAttribute('aria-expanded','false');
    cartToggle?.setAttribute('aria-expanded','false');
    mobileMenuToggle?.setAttribute('aria-expanded','false');
    document.body.classList.remove('header-panel-open');
  };
  const openPanel = panel => {
    closePanels();
    panel.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('header-panel-open');
  };

  const renderSearch = (products, target = searchResults) => {
    if (!target) return;
    if (!products.length) {
      target.innerHTML = '<p class="search-message">Ingen produkter funnet.</p>';
      return;
    }
    target.innerHTML = products.map(product => {
      const image = product.image?.url || product.featured_image?.url || product.featured_image || '';
      const price = product.price_min ?? product.price;
      return `<a class="search-result" href="${escapeHtml(product.url)}">
        ${image ? `<img src="${escapeHtml(image)}" alt="" width="140" height="168">` : ''}
        <span><span class="search-result-title">${escapeHtml(product.title)}</span><span class="search-result-price">${money(price)}</span></span>
      </a>`;
    }).join('');
  };
  const fetchSearchProducts = async query => {
    const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
    if (!response.ok) throw new Error('Search failed');
    const data = await response.json();
    return data.resources?.results?.products || [];
  };
  const runSearch = async query => {
    if (!searchResults) return;
    if (query.length < 2) {
      searchResults.innerHTML = '';
      if (searchPanel) searchPanel.hidden = true;
      searchInput?.setAttribute('aria-expanded','false');
      return;
    }
    setHeaderOffset();
    searchPanel.hidden = false;
    searchInput?.setAttribute('aria-expanded','true');
    searchResults.innerHTML = '<p class="search-message">Søker…</p>';
    try {
      renderSearch(await fetchSearchProducts(query));
    } catch (_) {
      searchResults.innerHTML = '<p class="search-message">Søket kunne ikke lastes. Prøv igjen.</p>';
    }
  };
  const runMobileSearch = async query => {
    if (!mobileSearchResults) return;
    if (query.length < 2) {
      mobileSearchResults.innerHTML = '';
      return;
    }
    mobileSearchResults.innerHTML = '<p class="search-message">Søker…</p>';
    try {
      renderSearch(await fetchSearchProducts(query), mobileSearchResults);
    } catch (_) {
      mobileSearchResults.innerHTML = '<p class="search-message">Søket kunne ikke lastes. Prøv igjen.</p>';
    }
  };

  const renderCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    if (!cartBody || !cartFooter || !cartTotal) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="cart-empty"><p>Handlekurven din er tom.</p><a class="text-button" href="/collections/alle-produkter">Utforsk produktene <span class="link-arrow" aria-hidden="true">→</span></a></div>';
      cartFooter.hidden = true;
      return;
    }
    cartBody.innerHTML = cart.items.map(item => `<article class="cart-line">
      ${item.image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.product_title)}" width="184" height="232"></a>` : ''}
      <div class="cart-line-copy">
        <a class="cart-line-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-line-variant">${escapeHtml(item.variant_title)}</span>` : ''}
        <div class="cart-line-bottom"><span class="cart-line-price">${item.quantity} × ${money(item.final_price)}</span><button class="cart-remove" type="button" data-cart-remove="${escapeHtml(item.key)}">Fjern</button></div>
      </div>
    </article>`).join('');
    cartTotal.textContent = money(cart.total_price);
    cartFooter.hidden = false;
  };
  const loadCart = async () => {
    if (cartBody) cartBody.innerHTML = '<p>Laster handlekurven…</p>';
    try {
      const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart failed');
      const cart = await response.json();
      renderCart(cart);
    } catch (_) {
      if (cartBody) cartBody.innerHTML = '<p>Handlekurven kunne ikke lastes. Prøv igjen.</p>';
    }
  };
  const openCart = async () => {
    if (!cartDrawer) return;
    openPanel(cartDrawer);
    cartToggle?.setAttribute('aria-expanded','true');
    await loadCart();
    cartClose?.focus();
  };

  cartToggle?.addEventListener('click', event => { event.preventDefault(); openCart(); });
  cartClose?.addEventListener('click', closePanels);
  mobileMenuToggle?.addEventListener('click', () => {
    if (!mobileMenu) return;
    openPanel(mobileMenu);
    mobileMenuToggle.setAttribute('aria-expanded','true');
    mobileMenuClose?.focus();
  });
  mobileMenuClose?.addEventListener('click', closePanels);
  overlay?.addEventListener('click', closePanels);
  addEventListener('resize', setHeaderOffset);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closePanels(); });

  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => runSearch(searchInput.value.trim()), 220);
  });
  searchForm?.addEventListener('submit', event => {
    event.preventDefault();
    runSearch(searchInput?.value.trim() || '');
  });
  mobileSearchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => runMobileSearch(mobileSearchInput.value.trim()), 220);
  });
  mobileSearchForm?.addEventListener('submit', event => {
    event.preventDefault();
    runMobileSearch(mobileSearchInput?.value.trim() || '');
  });
  document.addEventListener('click', event => {
    if (!searchPanel || searchPanel.hidden) return;
    if (searchPanel.contains(event.target) || searchForm?.contains(event.target)) return;
    searchPanel.hidden = true;
    searchInput?.setAttribute('aria-expanded','false');
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-add]');
    const original = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Legger til…'; }
    try {
      const response = await fetch(`${root}cart/add.js`, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Add failed');
      await openCart();
    } catch (_) {
      if (button) button.textContent = 'Prøv igjen';
    } finally {
      if (button) {
        window.setTimeout(() => { button.disabled = false; button.innerHTML = original; }, 800);
      }
    }
  });
  cartBody?.addEventListener('click', async event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    remove.disabled = true;
    try {
      const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})});
      if (!response.ok) throw new Error('Remove failed');
      renderCart(await response.json());
    } catch (_) {
      remove.disabled = false;
    }
  });
})();

(() => {
  const sections = [...document.querySelectorAll('[data-scroll-manifesto]')];
  if (!sections.length) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  sections.forEach(section => {
    section.querySelectorAll('.manifesto-word').forEach(word => {
      const letters = [...word.textContent];
      word.textContent = '';
      letters.forEach(letter => {
        const span = document.createElement('span');
        span.className = 'manifesto-char';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = letter;
        word.appendChild(span);
      });
    });
  });
  if (reducedMotion) return;
  let ticking = false;
  const clamp = (n,min,max) => Math.min(Math.max(n,min),max);
  const update = () => {
    const vh = window.innerHeight;
    sections.forEach(section => {
      const heading = section.querySelector('.manifesto--center p');
      const chars = [...section.querySelectorAll('.manifesto-char')];
      if (!heading || !chars.length) return;
      const rect = heading.getBoundingClientRect();
      const scrollStart = vh * .9;
      const scrollEnd = vh * .4 - rect.height / 2;
      const progress = clamp((scrollStart - rect.top) / Math.max(scrollStart - scrollEnd, 1), 0, 1);
      const duration = .5;
      const stagger = .1;
      const total = duration + stagger * Math.max(chars.length - 1, 0);
      chars.forEach((char,index) => {
        const start = index * stagger / total;
        const strength = clamp((progress - start) / (duration / total), 0, 1);
        char.style.opacity = String(.2 + strength * .8);
      });
    });
    ticking = false;
  };
  const requestUpdate = () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } };
  addEventListener('scroll', requestUpdate, {passive:true});
  addEventListener('resize', requestUpdate);
  update();
})();

(() => {
  document.querySelectorAll('[data-review-slider]').forEach(slider => {
    const track = slider.querySelector('[data-review-track]');
    const cards = [...slider.querySelectorAll('.review-card')];
    const dots = [...slider.querySelectorAll('.review-dot')];
    const prev = slider.querySelector('[data-review-prev]');
    const next = slider.querySelector('[data-review-next]');
    if (!track || !cards.length) return;

    const getIndex = () => {
      const left = track.scrollLeft;
      let closest = 0;
      let distance = Infinity;
      cards.forEach((card,index) => {
        const delta = Math.abs(card.offsetLeft - left);
        if (delta < distance) { distance = delta; closest = index; }
      });
      return closest;
    };
    const getPerPage = () => matchMedia('(max-width: 760px)').matches ? 1 : 2;
    const getPage = () => Math.round(getIndex() / getPerPage());
    const update = () => {
      const perPage = getPerPage();
      const page = getPage();
      const pageCount = Math.ceil(cards.length / perPage);
      dots.forEach((dot,i) => dot.classList.toggle('is-active', i === page * perPage));
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= pageCount - 1;
    };
    const go = direction => {
      const perPage = getPerPage();
      const pageCount = Math.ceil(cards.length / perPage);
      const page = Math.min(Math.max(getPage() + direction, 0), pageCount - 1);
      const index = Math.min(page * perPage, cards.length - 1);
      track.scrollTo({left:cards[index].offsetLeft,behavior:'smooth'});
    };
    prev?.addEventListener('click', () => go(-1));
    next?.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), {passive:true});
    addEventListener('resize', update);
    update();
  });
})();
